import { FC } from 'react';
import { Tooltip } from 'primereact/tooltip';

interface StepNodeActionButtonProps {
  onClick: (e: React.MouseEvent) => void;
  title: string;
  variant: 'add' | 'delete';
  disabled?: boolean;
}

export const StepNodeActionButton: FC<StepNodeActionButtonProps> = ({ onClick, title, variant, disabled = false }) => {
  const colorClasses = variant === 'add' ? 'border-blue-500 bg-blue-500' : 'border-red-500 bg-red-500';
  const iconClass = variant === 'add' ? 'pi pi-plus' : 'pi pi-trash';
  const tooltipClass = `step-action-btn-${variant}`;

  return (
    <>
      <Tooltip target={`.${tooltipClass}`} />
      <button
        type="button"
        className={`${tooltipClass} inline-flex items-center justify-center border-2 ${colorClasses} text-white shadow-sm flex-shrink-0 rounded-full text-xs ${
          disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
        }`}
        style={{ width: '2rem', height: '2rem', padding: 0 }}
        onClick={disabled ? undefined : onClick}
        data-pr-tooltip={title}
        data-pr-position="top"
        disabled={disabled}
      >
        <i className={iconClass} />
      </button>
    </>
  );
};

